// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainCartContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border: 1px solid #DCDFE1;
  border-radius: 0.5rem;
  box-shadow: none;
  margin-bottom: 0.5rem;
  min-height: 24rem;
}

.rowContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 1rem;
}

.unit {
  font-size: 0.8rem;
  font-style: italic;
  color: #6A6E73;
  margin-right: 0.2rem;
}

.unitDeposit {
  font-size: 0.6rem;
  font-style: italic;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Cart/Summary/summary.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AACF;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;AAAF","sourcesContent":[".mainCartContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  border: 1px solid #DCDFE1;\n  border-radius: 0.5rem;\n  box-shadow: none;\n  margin-bottom: 0.5rem;\n  min-height: 24rem;\n}\n\n.rowContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.8rem 1rem;\n}\n\n.unit {\n  font-size: 0.8rem;\n  font-style: italic;\n  color: #6A6E73;\n  margin-right: 0.2rem;\n}\n\n\n.unitDeposit {\n  font-size: 0.6rem;\n  font-style: italic;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
